import { ValidationErrors, UntypedFormGroup } from "@angular/forms";

export function emailOrPhoneValidator(control: UntypedFormGroup): ValidationErrors | null {
    const email = control.value.email;
    const phone = control.value.phone;

    return email || phone ? null : { emailOrPhone: true };
}
